const devWaiver = 'https://waiver.smartwaiver.com/w/604bd1a6dd9df/web/';
const prodWaiver = 'https://waiver.smartwaiver.com/w/561a69fb034b3/web/';
export const waiverURL = process.env.REACT_APP_ENV === 'prod' ? prodWaiver : devWaiver;
